import React from 'react';
import { KeyboardArrowDown } from '@mui/icons-material';

interface FilterSelectProps {
  title: string;
  onSelect: () => void;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({ onSelect, title }) => {
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '1px solid #D9DBE9',
        borderRadius: 15,
        height: 30,
        marginLeft: 5,
        marginRight: 5,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 14,
        paddingRight: 14
      }}
      onClick={onSelect}>
      <div>
        <p style={{ fontSize: 14, fontFamily: 'Arial' }}>{title}</p>
      </div>
      <div style={{ paddingTop: 5 }}>
        <KeyboardArrowDown />
      </div>
    </div>
  );
};
